var angular = require('angular');

var tooltipTemplate = require('html/templates/tooltip')();

tooltip.$inject = ['$compile', '$document', '$rootScope'];

function tooltip($compile, $document, $rootScope) {

  return {
    restrict: 'A',
    scope: true,

    link: function(scope, element, attrs) {
      var tooltipElement;

      element.attr('ng-click', '_openTooltip($event)');
      if (! attrs.mustClick) {
        element.attr('ng-mouseenter', '_openTooltip($event)');
        element.attr('ng-mouseleave', '_closeTooltip()');
      }
      element.removeAttr('tooltip');

      $compile(element)(scope);

      scope.$on('tooltipOpens', function(e, otherElem) {
        if (otherElem !== element) {
          scope._closeTooltip();
        }
      });

      scope._openTooltip = function(event) {
        var template = scope[attrs.tooltip];

        if (tooltipElement || ! template) return;

        $rootScope.$broadcast('tooltipOpens', element);

        template = tooltipTemplate.replace('{{ body }}', template);
        template = $compile(template)(scope);
        tooltipElement = angular.element(template);
        element
          .addClass('tooltip-open')
          .append(tooltipElement);

        event.stopImmediatePropagation();
        $document.on('keydown', closeOnEscape);
        $document.on('click', scope._closeTooltip);
      };

      scope._closeTooltip = function() {
        if (! tooltipElement) return;

        tooltipElement.remove();
        tooltipElement = null;
        element.removeClass('tooltip-open');

        $document.off('keydown', closeOnEscape);
        $document.off('click', scope._closeTooltip);
      };

      var closeOnEscape = function(event) {
        if (event.keyCode === 27) {  // ESC
          scope._closeTooltip();
        }
      };

    }

  };

}

module.exports = tooltip;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/tooltip.js
 ** module id = 159
 ** module chunks = 1
 **/